<template>
    <div>
        <form-row title="Zoning Changes"
            :no_border="true"
            class="mt-6"
            label_class="self-start pt-1"
        >
            <div class="w-full">
                <p v-if="! read_only"
                    class="text-gray-warm-800 text-base mb-0"
                >
                    {{ $t('List the zoning changes necessary for this closing:') }}
                </p>

                <div class="flex items-end font-semibold text-sm text-gray-warm-800 leading-snug mt-6">
                    <div class="flex flex-1 items-end mb-3">
                        <p class="w-1/2 mb-0">{{ $t('Items') }}</p>

                        <p class="w-1/4 mb-0">{{ $t('Who is Responsible?') }}</p>

                        <p class="w-1/4 mb-0">{{ $t('Completion Date') }}</p>
                    </div>

                    <div class="w-10">
                        <!-- // -->
                    </div>
                </div>

                <div v-for="(item, index) in zoning_change_items"
                    :key="item.id"
                    class="flex items-center border-b pb-2 mb-2"
                >
                    <zoning-change-item
                        :index="index"
                        :item="item"
                        :read_only="read_only"
                    />

                    <div
                        v-if="! read_only"
                        class="cursor-pointer flex hover:text-red-600 items-center justify-center text-gray-400 w-10"
                        @click="removeItem(item.id)"
                    >
                        <i class="fas fa-minus-circle"></i>
                    </div>
                </div>
            </div>
        </form-row>

        <button v-if="! read_only"
            type="button"
            class="flex items-center uppercase text-blue-500 hover:text-blue-600 leading-none focus:shadow-none ml-auto sm:ml-46 mt-2 mb-4"
        >
            <span class="text-xl font-bold mr-2">+</span>

            <span class="inline-block font-semibold text-sm py-2 cursor-pointer select-none"
                @click="addItem"
            >
                {{ $t('Add an item') }}
            </span>
        </button>

        <div v-else
            class="h-6 w-full"
        >
        </div>

        <div class="border-b border-gray-400"></div>
    </div>
</template>

<script>
import ZoningChangeItem from './zoning-change-item.vue';

export default {
    components: {
        ZoningChangeItem,
    },

    props: {
        commercial: {},
        read_only: { default: false },
    },

    data() {
        return {
            zoning_change_items: this.commercial.zoning_change_items || [],
            next_id: 1,
        }
    },

    methods: {
        addItem() {
            this.zoning_change_items.push({
                id: 'id_' + this.next_id++,
                name: null,
                responsible: null,
                completed_at: null,
            })
        },
        removeItem(id) {
            this.zoning_change_items.splice(this.zoning_change_items.findIndex(item => item.id == id), 1);

            if (! this.zoning_change_items.length) {
                this.addItem();
            }
        },
    },

    mounted() {
        if (! this.zoning_change_items.length) {
            this.addItem();
        }
    },
}
</script>
